var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getBrandByLocation } from '../businessLogics';
export var consoleLogExceptProd = function (isStrict) {
    var contents = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        contents[_i - 1] = arguments[_i];
    }
    if (process.env.REACT_APP_IS_DEV ? process.env.REACT_APP_IS_DEV === 'true' : !isStrict) {
        console.log.apply(console, contents);
    }
};
var throttlePool = {};
export var sendLog = function (action, CPL, data, userId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!throttlePool[action]) return [3, 2];
                consoleLogExceptProd(true, 'uid', userId);
                throttlePool[action] = true;
                return [4, CPL.sendCPLog(action, data)];
            case 1:
                _a.sent();
                setTimeout(function () {
                    throttlePool[action] = false;
                }, 100);
                return [3, 3];
            case 2:
                console.error('duplicate send log');
                _a.label = 3;
            case 3: return [2];
        }
    });
}); };
var sendGTM = function (key, data, attempt) {
    if (attempt === void 0) { attempt = 0; }
    if (typeof window.dataLayer === 'undefined') {
        if (attempt >= 10) {
            return;
        }
        return setTimeout(function () { return sendGTM(key, data, attempt + 1); }, 300);
    }
    try {
        data['event'] = key;
        window.dataLayer.push(data);
    }
    catch (error) {
        console.error('send gtm error: ', error);
    }
};
export var logSignupGtm = function (user, CPLogger) {
    var brand = getBrandByLocation();
    sendGTM('signup_completed', {
        onlineUserId: user._id,
        email: user.email,
        phone: user.phone,
        content_category: brand,
        brand: brand,
        content_type: '',
        content_name: '',
    });
};
//# sourceMappingURL=index.js.map